import React from 'react'
import { useTransition } from 'react-spring'
import { partition, stratify } from 'd3-hierarchy'

const BiggestSenders = props => {
  const { selection, f, countries, width } = props

  const hierarchy = stratify()
    .id(d => d.code)
    .parentId(d => d.parent)(
      [
        {
          code: 'ROOT',
          region: undefined,
          income_group: undefined,
          parent: undefined
        }
      ].concat(countries.map(d => ({ ...d, parent: 'ROOT' })))
    )
    .sum(d => {
      if (d.sendingToSelectedCountry) {
        return d.sendingToSelectedCountry()
      } else {
        return 0
      }
    })
    .sort((a, b) => b.value - a.value)

  const sendingPartition = partition()
    .size([width, 200])
    .padding(1)(hierarchy)

  return (
    <g className='sending-partition'>
      {selection && (
        <g>
          <text dx={5} dy={-20} style={{ fontSize: 14 }}>
            {props.top10Sources}
          </text>
          <rect
            y={-10}
            height={90}
            width={width}
            fill='url(#pattern-diagonal)'
          />
        </g>
      )}
      <g transform='translate(0, -210)'>
        {sendingPartition
          .descendants()
          .filter((d, i) => d.depth > 0 && i < 10)
          .map((cell, i) => (
            <g key={`sending-top-${i}`}>
              <rect
                y={cell.y1}
                x={cell.x0 * 1}
                height={90}
                width={(cell.x1 - cell.x0) * 1}
                rx={3}
                ry={3}
                stroke='#eaeaea'
                fill={cell.data.region.color}
              />
              <text
                style={{
                  fontSize: 12
                  // alignmentBaseline: 'central',,
                }}
                transform={`translate(${(cell.x1 + cell.x0) / 2}, ${cell.y1 +
                  100}) rotate(-45)`}
                textAnchor='end'
              >
                {cell.x1 - cell.x0 > 10 ? cell.data.label : '...'}
              </text>
              {cell.x1 - cell.x0 > 50 && (
                <g>
                  <text
                    x={(cell.x1 + cell.x0) / 2}
                    y={45 + cell.y1}
                    style={{
                      fontSize: 13,
                      alignmentBaseline: 'central',
                      textAnchor: 'middle',
                      fill: 'black',
                      fontWeight: 'bold'
                    }}
                  >
                    {`$${f(
                      cell.data.sendingToSelectedCountry() * 1000000
                    ).replace(/G/, 'B')}`}
                  </text>
                </g>
              )}
            </g>
          ))}
      </g>
    </g>
  )
}

export default BiggestSenders
